import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function News() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/blog?published_only=true`);
      setPosts(response.data);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white" data-testid="news-page">
      <section className="py-24 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl sm:text-6xl font-unbounded font-black mb-8"
            data-testid="news-title"
          >
            News & Updates
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl font-manrope max-w-4xl"
          >
            Latest updates from AI House USA.
          </motion.p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <p className="text-center font-manrope text-gray-500">Loading posts...</p>
          ) : posts.length === 0 ? (
            <div className="text-center py-16" data-testid="no-posts-message">
              <p className="text-xl font-manrope text-gray-500">No posts yet. Check back soon!</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((post, index) => (
                <motion.article
                  key={post.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white border border-black/10 hover:border-accent transition-colors"
                  data-testid={`blog-post-${post.id}`}
                >
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-sm font-manrope text-gray-500 mb-4">
                      <Calendar size={16} />
                      <span>{new Date(post.created_at).toLocaleDateString()}</span>
                    </div>
                    <h2 className="text-2xl font-unbounded font-bold mb-4">{post.title}</h2>
                    {post.excerpt && (
                      <p className="font-manrope text-gray-700 mb-6">{post.excerpt}</p>
                    )}
                    <Link
                      to={`/news/${post.slug}`}
                      className="inline-flex items-center gap-2 font-manrope font-medium text-accent hover:underline"
                      data-testid={`read-more-${post.slug}`}
                    >
                      Read More <ArrowRight size={16} />
                    </Link>
                  </div>
                </motion.article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
